// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","Wrap":"Wrap","PlanAheadBlock":"PlanAheadBlock","Title":"Title","PlanReasons":"PlanReasons","PlanReason":"PlanReason","IconContainer":"IconContainer","PlanReasonDescription":"PlanReasonDescription"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/GeneralPlanning/components/PlanAhead/css/PlanAhead.styl
// module id = 1310
// module chunks = 0